import React, {
	useCallback,
	useEffect,
	useMemo,
	useState
} from 'react';
import { useHistory } from 'react-router-dom';
import FullCalendar from '@fullcalendar/react';
import listPlugin from '@fullcalendar/list';
import { Loader, Segment } from 'semantic-ui-react';

import { handleError, log } from '../../../services/utils';

import { getCalendarEvents } from '../../../api/nora/calendar';

import { useAuthState } from '../../../contexts/AuthContext';

import {
	useCalendarState,
	useCalendarAction
} from '../../../contexts/CalendarContext';
import { useUIAction } from '../../../contexts/UIContext';

const CalendarSummary = () => {
	const history = useHistory();

	const { user: { permissions } } = useAuthState();
	const {
		calendarEvents,
		initialized
	} = useCalendarState();
	const { setCalendarEvents } = useCalendarAction();
	const {
		setApiErrorAlert,
		setInfobarLoader
	} = useUIAction();

	const [ isLoading, setIsLoading ] = useState( true );

	const retrieveCalendarEvents = useCallback( async () => {
		setInfobarLoader( 'Retrieving Calendar Events...' );

		try {
			const data = await getCalendarEvents();

			setCalendarEvents( data[ 0 ].events );
		} catch ( error ) {
			setApiErrorAlert( error );
			throw error;
		}
	}, [
		setInfobarLoader,
		setCalendarEvents,
		setApiErrorAlert
	] );

	useEffect( () => {
		( async () => {
			if ( !initialized ) {
				setInfobarLoader( 'Please wait...' );
			} else {
				if ( permissions.listCalendarEvents.canExecute && permissions.listCalendarEvents.isAvailable ) {
					try {
						await retrieveCalendarEvents();

						setInfobarLoader( '' );
					} catch ( error ) {
						if ( error.message !== 'canceled' ) {
							handleError( error );
							setInfobarLoader( '' );
						}
					}
				} else {
					setInfobarLoader( '' );
				}

				setIsLoading( false );
			}
		} )();
	}, [
		initialized,
		permissions,
		retrieveCalendarEvents,
		setInfobarLoader
	] );

	const events = useMemo( () => calendarEvents.map( ( {
		id,
		labels,
		end,
		start,
		subject
	} ) => ( {
		...labels.length && {
			backgroundColor: labels[ 0 ].color,
			borderColor: labels[ 0 ].color
		},
		end: new Date( end ),
		id,
		start: new Date( start ),
		title: subject
	} ) ), [ calendarEvents ] );

	const calendarPugins = useMemo( () => [ listPlugin ], [] );

	const eventClick = useCallback( info => {
		history.push( `/operations/calendar/${ info.event.id }` );
	}, [ history ] );

	const headerToolbar = useMemo( () => ( {
		left: 'prev,next',
		center: 'title',
		right: ''
	} ), [] );

	return (
		<>
			{ log( 'calendarSummary' ) }
			<Segment
				style={ {
					flex: 1,
					margin: '2rem 2rem 2rem 0',
					minHeight: '343px',
					minWidth: '300px'
				} }
			>
				{ isLoading
					? <Loader
						active
						content="Retrieving calendar events..."
					/>
					:	<FullCalendar
						eventClick={ eventClick }
						events={ events }
						eventDisplay="block"
						fixedWeekCount={ false }
						headerToolbar={ headerToolbar }
						height="100%"
						plugins={ calendarPugins }
						initialView="listWeek"
					/>
				}
			</Segment>
		</>
	);
};

export default CalendarSummary;
